import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";
import "@/styles/styles.scss";
import "element-ui/lib/theme-chalk/index.css";
// import "bulma/css/bulma.css"
// import "bulma/sass/utilities/_all.sass"
// import "bulma/sass/grid/columns.sass"

import ElementUI from "element-ui";
// import "./registerServiceWorker";

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
